import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDownObjective, DBTextFieldObjective, CancelButton } from '_components';
import styles from './Common.module.css'

class ObservationAccJointMobEntry extends React.Component {

    removeMob() {
        this.props.removeChildRow(this.props.noteId, 'PTOBJECTIVEACCJOINTMOB', 'JM', this.props.mobEntry.JMNO);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        let sideOptions = [
            { id: 'Right', value: 'Right' },
            { id: 'Left', value: 'Left' },
            { id: 'Both', value: 'Both' }
        ];

        let planeOptions = [
            { id: 'Inferior', value: 'Inferior' },
            { id: 'Superior', value: 'Superior' },
            { id: 'A-P', value: 'A-P' },
            { id: 'P-A', value: 'P-A' },
            { id: 'Medial', value: 'Medial' },
            { id: 'Lateral', value: 'Lateral' },
            { id: 'Distraction', value: 'Distraction' },
            { id: 'All Planes', value: 'All Planes' }
        ];

        let endFeelOptions = [
            { id: 'Soft', value: 'Soft' },
            { id: 'Firm', value: 'Firm' },
            { id: 'Hard', value: 'Hard' },
            { id: 'Empty', value: 'Empty' },
            { id: 'Spasm', value: 'Spasm' },
            { id: 'Springy Block', value: 'Springy Block' },
            { id: 'Capsular', value: 'Capsular' },
            { id: 'Hypomobile', value: 'Hypomobile' },
            { id: 'Hypermobile', value: 'Hypermobile' },
            { id: 'WNL', value: 'WNL' }
        ];

        return (
            <div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <span className={styles.add_button} />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEACCJOINTMOB'
                        entityKeyColumn='JMNO'
                        entityKeyValue={this.props.id}
                        field='JMJOINT'
                        className={styles.mob_column_1}
                    />
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEACCJOINTMOB'
                        entityKeyColumn='JMNO'
                        entityKeyValue={this.props.id}
                        field='JMSIDE'
                        className={styles.mob_column_2}
                        customOptions={sideOptions}
                    />
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEACCJOINTMOB'
                        entityKeyColumn='JMNO'
                        entityKeyValue={this.props.id}
                        field='JMPLANE'
                        className={styles.mob_column_3}
                        customOptions={planeOptions}
                    />
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEACCJOINTMOB'
                        entityKeyColumn='JMNO'
                        entityKeyValue={this.props.id}
                        field='JMENDFEEL'
                        className={styles.mob_column_4}
                        customOptions={endFeelOptions}
                    />
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.removeMob()} />
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        noteId: noteId,
        oono: oono,
        mobEntry: state.entities.notes.PTOBJECTIVEACCJOINTMOB[ownprops.id],
        objUpdated
    };
}

const connectedObservationAccJointMobEntry = connect(mapStateToProps, mapDispatchToProps)(ObservationAccJointMobEntry);
export { connectedObservationAccJointMobEntry as ObservationAccJointMobEntry };


